import * as React from 'react';

import { CarouselImageModel } from 'models';

import { UitkCardMedia } from 'uitk-react-cards';
import { UitkFigure, UitkImage } from 'uitk-react-images';

export const CarouselCardImage: React.FunctionComponent<CarouselImageModel> = props => {
  if (!props || !props.url) {
    return null;
  }

  return (
    <UitkCardMedia>
      <UitkFigure>
        <UitkImage alt={props.description ? props.description : ''} src={props.url} placeholderImage={true} />
      </UitkFigure>
    </UitkCardMedia>
  );
};
